import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { lazy, Suspense } from "react";
import Layout from "./components/Layout";
import ScrollToTop from "./components/ScrollToTop";
import Loading from "./components/Loading";

const Index = lazy(() => import("@/pages/Index"));
const Contact = lazy(() => import("@/pages/Contact"));
const NotFound = lazy(() => import("@/pages/NotFound"));
const AdminPanel = lazy(() => import("@/pages/AdminPanel"));
const Blog = lazy(() => import("@/pages/Blog"));
const BlogDetail = lazy(() => import("@/pages/BlogDetail"));
const AboutPage = lazy(() => import("@/pages/AboutPage"));
const ProjectsPage = lazy(() => import("@/pages/ProjectsPage"));
const ProjectDetail = lazy(() => import("@/pages/ProjectDetail"));
const FAQPage = lazy(() => import("@/pages/FAQPage"));
const ReviewsPage = lazy(() => import("@/pages/ReviewsPage"));
const PrivacyPolicy = lazy(() => import("@/pages/PrivacyPolicy"));
const TermsPage = lazy(() => import("@/pages/TermsPage"));
const CookiePolicy = lazy(() => import("@/pages/CookiePolicy"));
const LicensePage = lazy(() => import("@/pages/LicensePage"));
const Services = lazy(() => import("@/pages/Services"));
const UsesPage = lazy(() => import("@/pages/UsesPage"));

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <Suspense fallback={<Loading />}>
            <Layout>
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:blogId" element={<BlogDetail />} />
                <Route path="/projects" element={<ProjectsPage />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/project/:projectId" element={<ProjectDetail />} />
                <Route path="/admin-panel" element={<AdminPanel />} />
                <Route path="/faq" element={<FAQPage />} />
                <Route path="/reviews" element={<ReviewsPage />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/cookies" element={<CookiePolicy />} />
                <Route path="/license" element={<LicensePage />} />
                <Route path="/services" element={<Services />} />
                <Route path="/uses" element={<UsesPage />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Layout>
          </Suspense>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
